import StoryPage from "%/dynamic-component-editor/standard-pages/story-page/story-page";
import ErrorPage from "%/dynamic-component-editor/standard-pages/error-page/error-page";

export const STANDARD_PAGE_CLASS_BY_SLUG = {
  "story/{story_id}": StoryPage,
  "error": ErrorPage,
};

export function resolveStandardPageClass(slug) {
  return STANDARD_PAGE_CLASS_BY_SLUG[slug] ?? null;
}
